export function makeProduct(payload) {
  return Product.fromPayload(payload);
}

export class Product {
  constructor() {
    this._id = null;
    this._code = null;
    this._name = null;
  }

  static fromPayload(payload) {
    let product = new Product();
    product.id = payload.id;
    product.code = payload.code;
    product.name = payload.name;

    return product;
  }

  set id(id) {
    this._id = id;
  }

  get id() {
    return this._id;
  }

  set code(code) {
    this._code = code;
  }

  get code() {
    return this._code;
  }

  set name(name) {
    this._name = name;
  }

  get name() {
    return this._name;
  }
}


// WEBPACK FOOTER //
// ./client/app/api/models/product.model.js